module.exports = __webpack_public_path__ + "static/home-bg-167f02e06c7dfdbefa9f5231f46ea9d9.jpeg";